import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"
import { Navigation, A11y } from "swiper/modules"

// Carrousel de cartes avec les flèches de la maquette.
// desktopOnly : sur mobile les cartes restent en grille (logos clients).
export default class extends Controller {
  static targets = ["swiper", "prev", "next"]
  static values = { desktopOnly: Boolean }

  connect() {
    if (!this.desktopOnlyValue) {
      this.start()
      return
    }
    this.query = window.matchMedia("(min-width: 992px)")
    this.toggle = () => (this.query.matches ? this.start() : this.stop())
    this.query.addEventListener("change", this.toggle)
    this.toggle()
  }

  start() {
    if (this.swiper) return
    this.swiper = new Swiper(this.swiperTarget, {
      modules: [Navigation, A11y],
      slidesPerView: "auto",
      spaceBetween: this.desktopOnlyValue ? 9 : 15,
      watchOverflow: true,
      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
        disabledClass: "is-disabled",
      },
      breakpoints: {
        992: { spaceBetween: this.desktopOnlyValue ? 9 : 20 },
      },
      a11y: {
        prevSlideMessage: "Précédent",
        nextSlideMessage: "Suivant",
      },
    })
  }

  stop() {
    this.swiper?.destroy(true, true)
    this.swiper = null
  }

  disconnect() {
    this.query?.removeEventListener("change", this.toggle)
    this.stop()
  }
}
